import type {SVGProps} from 'react'
const WishlistActiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M250 175c0-41.4 33.6-75 75-75h350c41.4 0 75 33.6 75 75v721.7L500 730 250 896.7z"
      clipRule="evenodd"
    />
  </svg>
)
export {WishlistActiveIcon}
